import {
  acknowledgement_rows,
  acknowledgement_stats,
  approval_rows,
  approval_stats,
  category_cards,
  exception_rows,
  exception_status_options,
  policy_approval_stage_options,
  policy_board_approval_options,
  policy_category_options,
  policy_review_status_options,
  policy_status_options,
  policy_tabs,
  register_rows,
  review_rows
} from './compliance_policies_data';
import {
  create_empty_exception_form,
  create_empty_policy_form,
  deep_clone,
  prepare_exception_rows,
  prepare_register_rows
} from './compliance_policies_helpers';
import {
  policies_before_destroy,
  policies_computed,
  policies_methods,
  policies_mounted,
  policies_watch
} from './compliance_policies_ui';

export default {
  name: 'ComplyonPolicies',
  data: () => ({
    policy_tabs,
    register_rows: prepare_register_rows(deep_clone(register_rows)),
    approval_stats: deep_clone(approval_stats),
    approval_rows: deep_clone(approval_rows),
    acknowledgement_stats: deep_clone(acknowledgement_stats),
    acknowledgement_rows: deep_clone(acknowledgement_rows),
    exception_rows: prepare_exception_rows(deep_clone(exception_rows)),
    category_cards: deep_clone(category_cards),
    review_rows: deep_clone(review_rows),
    active_category_filter: category_cards[0].title,
    policy_category_options,
    policy_status_options,
    policy_approval_stage_options,
    policy_board_approval_options,
    policy_review_status_options,
    exception_status_options,
    active_tab: 'register',
    active_policy_ref: null,
    policy_drawer_open: false,
    policy_modal_open: false,
    policy_modal_mode: 'create',
    policy_modal_index: null,
    policy_modal_form: create_empty_policy_form(),
    exception_modal_open: false,
    exception_modal_mode: 'create',
    exception_modal_index: null,
    exception_modal_form: create_empty_exception_form()
  }),
  computed: policies_computed,
  methods: policies_methods,
  mounted: policies_mounted,
  beforeDestroy: policies_before_destroy,
  watch: policies_watch
};
